<template>
    <v-card >
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                Add Branch
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-row>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    label="Branch Name"
                                    v-model="branchData.name"
                                    :error-messages="branchNameErrors"
                                    required
                                    @input="$v.branchData.name.$touch()"
                                    @blur="$v.branchData.name.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6"
                               v-if="isSuperAdmin">
                            <v-autocomplete
                                    v-model="branchData.companyID"
                                    :error-messages="branchCompanyErrors"
                                    required
                                    @input="$v.branchData.companyID.$touch()"
                                    @blur="$v.branchData.companyID.$touch()"
                                    :items="companyList"
                                    label="Company"
                                    clearable
                                    single-line
                                    item-text="value"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>
<!--                        <v-col cols="12"-->
<!--                               md="4"-->
<!--                               sm="6"-->
<!--                               v-if="isSuperAdmin || isCompany">-->
<!--                            <v-autocomplete-->
<!--                                    v-model="branchData.departmentID"-->
<!--                                    :error-messages="branchDepartmentErrors"-->
<!--                                    required-->
<!--                                    @input="$v.branchData.departmentID.$touch()"-->
<!--                                    @blur="$v.branchData.departmentID.$touch()"-->
<!--                                    :items="departmentList"-->
<!--                                    label="Department"-->
<!--                                    clearable-->
<!--                                    single-line-->
<!--                                    item-text="value"-->
<!--                                    item-value="id"-->
<!--                            ></v-autocomplete>-->
<!--                        </v-col>-->
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    label="Branch Address"
                                    v-model="branchData.address"
                                    :error-messages="branchAddressErrors"
                                    required
                                    @input="$v.branchData.address.$touch()"
                                    @blur="$v.branchData.address.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    label="Branch Code" v-model="branchData.code"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu"
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="branchData.establishedYear"
                                            label=" Establishment Year"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                            :error-messages="branchEstablishedYearErrors"
                                            required
                                            @input="$v.branchData.establishedYear.$touch()"
                                            @blur="$v.branchData.establishedYear.$touch()"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                        v-model="branchData.establishedYear"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    :label=" ' Email'"
                                    v-model="branchData.email"
                                    :error-messages="branchEmailErrors"
                                    required
                                    @input="$v.branchData.email.$touch()"
                                    @blur="$v.branchData.email.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    :label=" ' Website'"
                                    v-model="branchData.website"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    :label=" ' Phone Number'"
                                    v-model="branchData.phoneNumber"
                                    :error-messages="branchPhoneNumberErrors"
                                    required
                                    @input="$v.branchData.phoneNumber.$touch()"
                                    @blur="$v.branchData.phoneNumber.$touch()"
                            ></v-text-field>
                        </v-col>
                       <!-- <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-file-input
                                    show-size
                                    label="Logo"
                            ></v-file-input>
                        </v-col>-->
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-switch
                                    class="col-sm-6 col-md-4"
                                    v-model="branchData.isActive"
                                    required
                                    label="Is Active?"
                                    clearable
                            ></v-switch>
                        </v-col>
                        <!--<v-col cols="12"
                               md="12"
                               sm="12">
                            <v-textarea
                                    name="input-7-1"
                                    label="About us"
                                    value=""
                                    rows="2"
                            ></v-textarea>
                        </v-col>-->
                    </v-row>
                </form>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn class="custom-save-button" @click="submit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "createBranchForm",
        props: ["success"],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            branchAddressErrors() {
                const errors = [];
                if (!this.$v.branchData.address.$dirty) return errors;
                !this.$v.branchData.address.required &&
                errors.push("Branch Address is required");
                return errors;
            },
            branchNameErrors() {
                const errors = [];
                if (!this.$v.branchData.name.$dirty) return errors;
                !this.$v.branchData.name.required &&
                errors.push("Branch name is required.");
                return errors;
            },
            branchPhoneNumberErrors() {
                const errors = [];
                if (!this.$v.branchData.phoneNumber.$dirty) return errors;
                !this.$v.branchData.phoneNumber.required &&
                errors.push("Branch Phone Number is required.");
                return errors;
            },
            // branchEstablishedYearErrors() {
            //     const errors = [];
            //     if (!this.$v.branchData.establishedYear.$dirty) return errors;
            //     !this.$v.branchData.establishedYear.required &&
            //     errors.push("Branch Establishment year is required.");
            //     return errors;
            // },
            branchEmailErrors() {
                const errors = [];
                if (!this.$v.branchData.email.$dirty) return errors;
                !this.$v.branchData.email.required &&
                errors.push("Branch Email is required.");
                return errors;
            },
            branchCompanyErrors() {
                const errors = [];
                if (!this.$v.branchData.companyID.$dirty) return errors;
                !this.$v.branchData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
        },
        data() {
            return {
                created: false,
                branchData: {},
                selectedCompany:null,
                companyList : [],
                departmentList : [],
                snackbar: {
                    dateMenu: false,
                    servicesData:{
                        data:{},
                        message:"",
                        color:""
                    },
                }
            };
        },
        mounted() {
            this.checkUserRole()
            this.formData()
        },
        validations: {
            branchData: {
                name: { required },
                companyID: { required },
                email: { required },
                address: { required },
                // establishedYear: { required },
                phoneNumber: { required },
            }
        },
        methods: {
            checkUserRole(){
                if(!this.isSuperAdmin && !this.isCompany){
                    this.branchData.departmentID = parseInt(this.usersData.departmentID)
                    this.branchData.companyID = parseInt(this.usersData.companyID)
                }
                if(this.isCompany && !this.isSuperAdmin){
                    this.branchData.companyID = parseInt(this.usersData.companyID)
                }
            },
            dialogueClose() {
                this.branchData = {};
                this.$emit("dialogueClose");
            },
            // async getDepartmentList(index){
            //     let departmentList = await axios.get("Department/DDLDepartmentList?CompanyID=" + index)
            //     this.departmentList = departmentList.data
            //     this.branchList = []
            // },
            async formData(){
                console.log(parseInt(this.usersData.companyID))
                axios.get("Company/DDLCompanyList").then(response=>{
                    this.companyList = response.data
                })
            },
            formResponse() {
                this.$emit("formResponse", this.snackbar.servicesData);
                this.dialogueClose();
            },
            submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    axios.post("Branch/Create", this.branchData).then(response => {
                        if (response.data.success) {
                            this.snackbar.servicesData.data=response.data
                            this.snackbar.servicesData.message="Branch added Successfully"
                            this.snackbar.servicesData.color="success"
                            this.formResponse()
                        }
                    }).catch(response=>{
                        this.snackbar.servicesData.data=response.data
                        this.snackbar.servicesData.message="Error Adding Branch, Please Contact Admin"
                        this.snackbar.servicesData.color="error"
                        this.formResponse()
                    });
                }
            },
            clear() {
                this.$v.$reset();
                this.branchData = {};
            },
        }
    };
</script>

<style scoped>
</style>
